import React, { useState, useRef, useEffect } from 'react';
import { Sk } from '../../components/Skeleton';
import SessionItem from '../../components/SessionItem';
import { useChatPlatform } from '../context/ChatPlatformContext';
import { useSessions } from '../store/hooks';
import { AddNewChatIcon } from './icons';

const LOAD_BATCH = 30;

export default function SessionList({
    isInitializing,
    editingSessionId,
    editingName,
    setEditingName,
    openMenuSessionId,
    setOpenMenuSessionId,
    switchSession,
    startEditing,
    handleRenameSession,
    handleDeleteSession,
}) {
    const { activeSessionId, isMobile, isSidebarOpen, setIsSidebarOpen } = useChatPlatform();
    const sessions = useSessions();
    const [visibleCount, setVisibleCount] = useState(LOAD_BATCH);
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (!sentinelRef.current || !sessions) return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) setVisibleCount(c => c + LOAD_BATCH);
        });
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [visibleCount, sessions]);

    return (
        <div className={`flex-1 overflow-y-auto px-2 pb-2 mt-4 scroll-container transition-opacity duration-200 ${(isSidebarOpen || isMobile) ? 'opacity-100' : 'opacity-0 hidden'}`}>
            <div className="px-2 pt-2 pb-1">
                <h3 className="text-[13px] font-normal text-gray-400 tracking-wide">Tất cả cuộc trò chuyện</h3>
            </div>
            <div className="space-y-1 mt-0">
                {isInitializing ? (
                    <div className="relative overflow-hidden">
                        <div className="space-y-1">
                            {Array.from({ length: 16 }).map((_, i) => (
                                <div key={i} className="px-2 py-0.5">
                                    <Sk h={20} r="rounded-md" />
                                </div>
                            ))}
                        </div>
                        <div
                            className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
                            style={{ background: 'linear-gradient(to top, var(--app-sidebar) 10%, transparent 100%)' }}
                        />
                    </div>
                ) : sessions && sessions.length > 0 ? (
                    <>
                        {sessions.slice(0, visibleCount).map(session => (
                            <SessionItem
                                key={session.session_id}
                                session={session}
                                isActive={session.session_id === activeSessionId}
                                isEditing={editingSessionId === session.session_id}
                                editingName={editingName}
                                isMenuOpen={openMenuSessionId === session.session_id}
                                onMenuToggle={(isOpen) => setOpenMenuSessionId(isOpen ? session.session_id : null)}
                                onSelect={(sessionId) => {
                                    if (isMobile) setIsSidebarOpen(false);
                                    switchSession(sessionId);
                                }}
                                onStartEdit={startEditing}
                                onRename={handleRenameSession}
                                onDelete={handleDeleteSession}
                                onEditNameChange={setEditingName}
                            />
                        ))}
                        {visibleCount < sessions.length && (
                            <div ref={sentinelRef} className="h-8" />
                        )}
                    </>
                ) : (
                    <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                        <AddNewChatIcon />
                        <p className="text-xs text-gray-400 leading-relaxed">Tạo cuộc trò chuyện mới để bắt đầu</p>
                    </div>
                )}
            </div>
        </div>
    );
}
